<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            <form [formGroup]="floorPlanInformation" class="text-dark">
                <div class="row">
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="accountNumber">{{ words[language][ 'accountNumber' ] }}</label>
                        <input class="form-control text-dark" type="text" id="accountNumber" formControlName="accountNumber" autocomplete="off">
                        @if (accountNumber.invalid && accountNumber.dirty) {
                            <span class="text-danger">{{words[language][ 'invalidNumber' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="apr">APR</label>
                        <percent-input id="apr" [control]="floorPlanInformation.get('apr')"></percent-input>
                        @if (apr.invalid && apr.dirty) {
                            <span class="text-danger">{{ words[language][ 'invalid' ] }} APR</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="daysPerYear">{{ words[language][ 'daysPerYear' ] }}</label>
                        <count-input id="daysPerYear" [control]="floorPlanInformation.get('daysPerYear')"></count-input>
                        @if (daysPerYear.invalid && daysPerYear.dirty) {
                            <span class="text-danger">{{words[language]['invalidDays' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label for="daysAllowed">{{ words[language][ 'daysAllowed' ] }}</label>
                        <count-input id="daysAllowed" [control]="floorPlanInformation.get('daysAllowed')"></count-input>
                        @if (daysAllowed.invalid && daysAllowed.dirty) {
                            <span class="text-danger">{{words[language]['invalidDays' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label>Default Reduction Amount</label>
                        <currency-input id="reductionAmountreductionAmount" [control]="floorPlanInformation.get('reductionAmount')"></currency-input>
                        @if (reductionAmount.invalid && reductionAmount.dirty) {
                            <span class="text-danger">{{words[language][ 'invalidNumber' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label class="text-nowrap" for="reductionFrequency">Payment Frequency</label>
                        <select class="form-control" formControlName="reductionFrequency" name="reductionFrequency" id="reductionFrequency">
                            @for (frequency of paymentFrequency; track frequency) {
                                <option [value]="frequency.toLowerCase()">{{frequency}}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label> {{ words[language][ 'initialFeeAmount' ] }}</label>
                        <currency-input id="initialFeeAmount" [control]="floorPlanInformation.get('initialFeeAmount')"></currency-input>
                        @if (initialFeeAmount.invalid && initialFeeAmount.dirty) {
                            <span class="text-danger">{{words[language][ 'invalidNumber' ] }}</span>
                        }
                    </div>
                    <div class="form-group col-md-3 col-sm-12">
                        <label class="text-nowrap">Default Fee Amount</label>
                        <currency-input id="feeAmount" [control]="floorPlanInformation.get('feeAmount')"></currency-input>
                        @if (feeAmount.invalid && feeAmount.dirty) {
                            <span class="text-danger">{{words[language][ 'invalidNumber' ] }}</span>
                        }
                    </div>
                </div>
            </form>
        </div>
        <div class="card-footer">
            <button class="btn btn-primary btn-sm" id="btn-save-inventory" (click)="save()" [disabled]="!floorPlanInformation.valid || loading || contactId == 0">
            @if (loading) {
                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
            } 
            {{ words[language][ 'save' ] }}</button>

            @if (calledFrom !== null) {
                <button class="btn btn-sm btn-primary">Cancel & Close</button>
            }
            <button class="btn btn-danger btn-sm" id="btn-clear-floorPlanSetup" (click)="clear()" [disabled]="contactId == 0">
                @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                }
                Delete Setup</button>
        </div>
    </div>
    @if (calledFrom == null) {
    <div class="text-right">
        <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
        <!-- <button class="btn btn-sm btn-success" (click)="reactivateRole()">Reactivate Role</button> -->
    </div>
    }
</div>
